import {
    getFolderIdByCalendarID,
    calendarFolderIdNeedsUpdate,
    getAndUpdateActualFolderId,
    getDefaultCalendar,
    getCalendarFolderId,
} from 'owa-calendar-cache';

export function getUpdatedFolderIds(calendarIds: string[]): string[] {
    return calendarIds.filter(id => !calendarFolderIdNeedsUpdate(id)).map(getFolderIdByCalendarID);
}

export {
    getFolderIdByCalendarID,
    calendarFolderIdNeedsUpdate,
    getAndUpdateActualFolderId,
    getDefaultCalendar,
    getCalendarFolderId,
};
